import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  body: {
    fontSize: "12px",
    padding: `5px 13px`
  }
});

function CustomLink(props) {
  const {
    link: { href, style },
    handleLink,
    d,
    detail
  } = props;
  const classes = useStyles();

  const onClick = useCallback(
    e => {
      e.stopPropagation();
      handleLink(detail || d);
    },
    [handleLink, detail, d]
  );

  return (
    <div className={classes.body}>
      {href ? (
        <a href={props.link.href} target={"_blank"}>
          {props.children}
        </a>
      ) : (
          <button style={style} onClick={onClick}>
            {props.children}
          </button>
        )}
    </div>
  );
}

export default CustomLink;
